export interface TransportationReportResult {
    reportId: string
}

export interface TransportationReport {
    transportDetails: TransportDetails
    shipments: (ShipmentEmpties | ShipmentMaterials)[]
}

export interface TransportDetails {
    freightForwarder: FreightForwarder
    transportMode: TransportMode
    borderoNumber: string
    accessCode?: string
    loading: Loading
    unloading: Unloading
}

export interface FreightForwarder {
    duns: string
    supplierCode: string
}

export const meansOfTransport = [
    "EUROTRAILER",
    "MEGATRAILER",
    "JUMBO_SWAP_BODY",
    "JUMBO_TRAILER_PULL",
    "TRUCK_7_5_TON",
    "VAN_OR_BUS",
    "CAR",
    "GIGALINER",
    "TAUTLINER",
    "GOOSENECK_CHASSIS",
] as const

export const fuelType = [
    "DIESEL",
    "DIESEL_AND_ELECTRIC",
    "ELECTRIC",
    "LIQUID_PROPANE_GAS",
    "PETROL",
    "PETROL_AND_ELECTRIC",
] as const

export interface TransportMode {
    type: "ROAD"
    meansOfTransport: typeof meansOfTransport[number]
    licensePlate: string
    fuelType?: typeof fuelType[number]
}

export const volumeUnit = [
    "CUBIC_DECIMETER", "LITER", "CUBIC_METER"
] as const

export interface Volume {
    unit: typeof volumeUnit[number]
    value: number
}

export const shipmentType = ["MATERIALS", "EMPTIES"] as const

interface BaseShipment {
    shipmentNumber: string
    shipFrom: ShipFrom
    volume: Volume | null
    type: typeof shipmentType[number]
}

export interface ShipToMaterials {
    duns: string
    plantCode: string
}

export interface ShipmentMaterials extends BaseShipment {
    type: "MATERIALS",
    shipTo: ShipToMaterials
}

export interface ShipToEmpties {
    duns: string
    supplierCode: string
}

export interface ShipmentEmpties extends BaseShipment {
    type: "EMPTIES"
    shipTo: ShipToEmpties
}

export type Shipment = ShipmentMaterials | ShipmentEmpties

export interface Loading {
    loadedAt: string
    duns: string
    supplierCode: string
}

export interface Unloading {
    unloadedAt: string
    duns: string
    supplierCode: string
}

export interface ShipFrom {
    duns: string
    supplierCode: string
}
